import React from "react";

const Classic = () => {
  return (
    <div>
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_4520_10656)">
          <path
            opacity="0.48"
            d="M48 0H24C10.7452 0 0 10.7452 0 24V48C0 61.2548 10.7452 72 24 72H48C61.2548 72 72 61.2548 72 48V24C72 10.7452 61.2548 0 48 0Z"
            fill="#FD7C54"
          />
          <g filter="url(#filter0_d_4520_10656)">
            <path
              d="M36 60C49.2548 60 60 49.2548 60 36C60 22.7452 49.2548 12 36 12C22.7452 12 12 22.7452 12 36C12 49.2548 22.7452 60 36 60Z"
              fill="white"
            />
          </g>
          <path
            d="M26 44.9997H36C36.2652 44.9997 36.5196 45.1051 36.7071 45.2926C36.8946 45.4801 37 45.7345 37 45.9997C37 46.2649 36.8946 46.5193 36.7071 46.7068C36.5196 46.8944 36.2652 46.9997 36 46.9997H26C25.7348 46.9997 25.4804 46.8944 25.2929 46.7068C25.1054 46.5193 25 46.2649 25 45.9997C25 45.7345 25.1054 45.4801 25.2929 45.2926C25.4804 45.1051 25.7348 44.9997 26 44.9997ZM29.24 32.0697L32.07 29.2397L44.8 41.9697C45.1753 42.345 45.3861 42.854 45.3861 43.3847C45.3861 43.9154 45.1753 44.4244 44.8 44.7997C44.4247 45.175 43.9157 45.3858 43.385 45.3858C42.8543 45.3858 42.3453 45.175 41.97 44.7997L29.24 32.0697ZM37.73 26.4097L40.56 29.2397C40.746 29.4255 40.8935 29.646 40.9941 29.8888C41.0948 30.1316 41.1466 30.3919 41.1466 30.6547C41.1466 30.9175 41.0948 31.1778 40.9941 31.4206C40.8935 31.6634 40.746 31.884 40.56 32.0697L39.14 33.4897L33.49 27.8297L34.9 26.4197C35.0851 26.2331 35.3051 26.0848 35.5476 25.9833C35.79 25.8818 36.0501 25.8291 36.3129 25.8281C36.5758 25.8272 36.8362 25.8781 37.0793 25.9779C37.3225 26.0777 37.5436 26.2244 37.73 26.4097ZM27.83 33.4797L33.49 39.1397L32.08 40.5497C31.8943 40.7357 31.6737 40.8832 31.4309 40.9838C31.1881 41.0845 30.9278 41.1363 30.665 41.1363C30.4022 41.1363 30.1419 41.0845 29.8991 40.9838C29.6563 40.8832 29.4357 40.7357 29.25 40.5497L26.42 37.7197C26.234 37.534 26.0865 37.3134 25.9859 37.0706C25.8852 36.8278 25.8334 36.5675 25.8334 36.3047C25.8334 36.0419 25.8852 35.7816 25.9859 35.5388C26.0865 35.296 26.234 35.0755 26.42 34.8897L27.83 33.4797Z"
            fill="#292929"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_4520_10656"
            x="6"
            y="9"
            width="60"
            height="60"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4520_10656"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_4520_10656"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_4520_10656">
            <rect width="72" height="72" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default Classic;
